// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import voteEntity from './entities/vote.json';
import voteMenu from '../pages/vote/menu.json';
import voteFullForm from '../pages/vote/forms/full.json';
import voteContextForm from '../pages/vote/forms/context.json';
import voteMiniForm from '../pages/vote/forms/mini.json';
import voteLookupForm from '../pages/vote/forms/lookup.json';
import voteTableView from '../pages/vote/views/table.json';
import voteStagesView from '../pages/vote/views/stages.json';
import voteCardsView from '../pages/vote/views/cards.json';
import voteSplitView from '../pages/vote/views/split.json';
import voteCalendarView from '../pages/vote/views/calendar.json';
import voteDashboardView from '../pages/vote/views/dashboard.json';

/** Тип запису «Голосування» зі сторінками пакета: меню, форми та подання з pages/vote/. */
export const voteDefinition: IRecordTypeDefinition = {
  ...voteEntity,
  views: assembleViewSet({
      table: voteTableView,
      stages: voteStagesView,
      cards: voteCardsView,
      split: voteSplitView,
      calendar: voteCalendarView,
      dashboard: voteDashboardView,
  }),
  form: voteFullForm,
  forms: { full: voteFullForm, context: voteContextForm, mini: voteMiniForm, lookup: voteLookupForm },
  menu: voteMenu,
} as IRecordTypeDefinition;
